export async function otpVerify(data) {
    const response = await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/verify/otp`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
        body: JSON.stringify(data)
      })
      // console.log(response);
    if (!response.ok && response.status != 400) {
      const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
    return await response.json();
}

export async function otpResend(data) {
  const response = await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/verify/otp`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
      body: JSON.stringify(data)
    })
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
  return await response.json();
}

export async function otpVerifycareer(data) {
  const response = await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/verify/otp`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
      body: JSON.stringify(data)
    })
    // console.log(response);
    if (!response.ok && response.status != 400) {
      const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
  return await response.json();
}

export async function otpResendcareer(data) {
const response = await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/resend/otp`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(data)
  })
  if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
return await response.json();
}
export async function otpVerifyleads(data) {
  const response = await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/verify/otp`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
      body: JSON.stringify(data)
    })
    console.log(response);
    if (!response.ok && response.status != 400) {
      const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
  return await response.json();
}

export async function otpResendleads(data) {
const response = await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/resend/otp`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(data)
  })
  if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
return await response.json();
}